<template>
  <v-container>
    <Dialog
      :show="adDialog"
      :correo="correo"
      :object="objDelete"
      @activate="activar"
      @email="enviarEmail"
      @deactivate="desactivar"
      @delete="eliminar"
      @close="close"
    />
    <Imprimir :reserva="true" :dialog="modalImprimir" :imprimir="imprimir" @close="close"/>
    <template>
      <v-expansion-panels v-model="panel" :readonly="readonly" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header class="headline"
            >Gestión</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" md="12">
                <Modal
                  @save="guardar"
                  @close="close"
                  :object="itemAct"
                  :update="update"
                  :detalle="detalle"
                  :show="abrirModal"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="headline"
            >Reservas programadas</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" md="12">
                <Table
                  @edit="handleEdit"
                  @delete="handleDelete"
                  @detalle="handleDetail"
                  @act="handleActivateDeactivate"
                  @imprimir="handlePrint"
                  @email="emailClick"
                  :headers="headers"
                  :arrayList="reservas"
                  :opciones="true"
                  :title="alquilerStr"
                  :reserva="true"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Table from "@/components/base/Table.vue";
import Modal from "@/components/base/modal/ModalReserva.vue";
import Dialog from "@/components/base/Dialog";
import Imprimir from "@/components/base/Imprimir";
import Headers from "../headers";
import moment from "moment";

export default {
  data() {
    return {
      headers: Headers.headersReservas,
      modoChart: "column",
      panel: [0, 1],
      adDialog: false,
      abrirModal: false,
      readonly: false,
      correo: false,
      ventaStr: "Coches a la venta",
      alquilerStr: "Todas las reservas",
      itemAct: {
        id:null,
        tarifa:0,
        total:0,
        usuario: null,
        id_coche: null,
        coche_modelo:null,
        coche_grupo:null,
        coche_matricula:null,
        id_persona: null,
        nombre: null,
        apellido: null,
        telefono: null,
        edad_conductor:null,
        tipo_francdepos: null,
        valor_francdepos: null,
        fecha_entrega: moment(new Date()).format("LL"),
        fecha_recogida: moment(new Date()).format("LL"),
        hora_entrega: null,
        hora_recogida: null,
        lugar_entrega: null,
        lugar_recogida: null,
        observaciones: null,
      },
      objDelete: {
        element: "Reserva",
        adAccion: 0,
        adId: "",
        adNombre: "",
        id: "",
        obj: {},
      },
      imprimir: [],
      update: false,
      detalle: false,
      modalImprimir: false,
    };
  },
  components: {
    Table,
    Modal,
    Dialog,
    Imprimir
  },
  async created() {
    moment.locale("ES");
    // this.calcularDeuda();
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario"]),
    ...mapState("reservaNamespace", ["reserva", "reservas"]),
    ...mapState("cocheNamespace", ["coches"]),
  },
  methods: {
    ...mapActions("cocheNamespace", ["getCoches"]),
    ...mapActions("reservaNamespace", [
      "getReserva",
      "getReservas",
      "saveReserva",
      "sendEmail",
      "updateReserva",
      "deleteReserva",
      "deactivateReserva",
      "activateReserva",
    ]),
    handleEdit(obj) {
      this.update = true;
      this.detalle = false;
      this.itemAct = obj;
      this.abrirModal = true;
    },
    handleDetail(obj) {
      this.detalle = true;
      this.itemAct = obj;
      this.abrirModal = true;
    },
    handleDelete(obj) {
      this.adDialog = true;
      this.objDelete.id = obj.id;
      this.objDelete.obj = obj;
    },
    handleActivateDeactivate(accion, item) {
      this.objDelete.adId = item.id;
      if (accion == 1) {
        this.objDelete.adAccion = 1; //"Activar Grupo"
        this.adDialog = true;
      } else if (accion == 2) {
        this.objDelete.adAccion = 2; //"Desactivar Grupo"
        this.adDialog = true;
      } else {
        this.adDialog = false;
      }
    },
    handlePrint(obj) {
      let coches = this.coches;
      let marca = '';
      debugger
      coches.forEach(e => {
        if(obj.id_coche == e.id) {
          marca = e.marca;
        }
      });
      this.imprimir = [];
      this.imprimir.push({
        id_reserva: obj.id,
        tarifa: obj.tarifa,
        total: obj.total,
        id_cliente: obj.id_persona,
        nombre: obj.nombre,
        apellido: obj.apellido,
        telefono: obj.telefono,
        email: obj.email,
        id_coche: obj.id_coche,
        marca: marca,
        modelo: obj.coche_modelo,
        matricula: obj.coche_matricula,
        grupo: obj.coche_grupo,
        tipo_francdepos: obj.tipo_francdepos,
        valor_francdepos: obj.valor_francdepos,
        fecha_entrega: obj.fecha_entrega,
        fecha_recogida: obj.fecha_recogida,
        hora_entrega: obj.hora_entrega,
        hora_recogida: obj.hora_recogida,
        lugar_entrega: obj.lugar_entrega,
        lugar_recogida: obj.lugar_recogida,
        persona: obj.persona,
        extra: obj.extra,
        observaciones: obj.observaciones,
      });
      this.modalImprimir = true;
    },
    emailClick(obj) {
      this.objDelete.adAccion = 3;
      this.objDelete.adId = obj.id;
      this.objDelete.obj = obj;
      this.correo = true;
      this.adDialog = true;
    },
    nuevo() {
      this.update = false;
      this.abrirModal = true;
    },
    guardar(obj) {
      if (this.update) {
        this.updateReserva({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      } else {
        this.saveReserva({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      }
      this.close();
      this.getCoches();
    },
    enviarEmail(obj) {
      debugger;
      this.sendEmail({
        token: this.token,
        res: obj,
      });
      this.close();
    },
    activar(id) {
      debugger;
      this.activateReserva({
        token: this.token,
        id: id,
      });
      this.close();
    },
    desactivar(id) {
      debugger
      this.deactivateReserva({
        token: this.token,
        id: id,
      });
      this.close();
    },
    eliminar(obj) {
      debugger;
      this.deleteReserva({
        token: this.token,
        id: obj,
      });
      this.close();
    },
    close() {
      this.detalle = false;
      this.update = false;
      this.itemAct = {};
      this.abrirModal = false;
      this.adDialog = false;
      this.modalImprimir = false;
    },
  },
};
</script>
